import { render, staticRenderFns } from "./ModalAssignCargo.vue?vue&type=template&id=a701b5da&"
import script from "./ModalAssignCargo.vue?vue&type=script&lang=js&"
export * from "./ModalAssignCargo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignCargo.vue?vue&type=style&index=0&id=a701b5da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports